import React from "react";
import { TbCertificate } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

function CertificateButton() {
  const navigate = useNavigate();

  return (
    <button onClick={() => navigate("/certificate")} class="group relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-medium text-white transition duration-300 ease-out bg-[#df670e] rounded-xl shadow-lg hover:scale-105 hover:shadow-xl">
      <TbCertificate className="mr-2 text-lg transition-transform duration-300 group-hover:rotate-12" />
      Download Certificate
    </button>
  );
}

export default CertificateButton;
